import React, { useState, useEffect } from "react";
import { Button, message, Spin } from "antd";
import _ from "lodash";
import $axios from "../services/axios";
import { useLocation, useHistory } from "react-router-dom";
import { LeftOutlined } from "@ant-design/icons";

const PaymentStatus = () => {
  const location = useLocation();
  const history = useHistory();
  const queryParams = new URLSearchParams(location.search);
  const [statusPayment, setStatusPayment] = useState(null);
  const [loading, setLoading] = useState(false);
  const [bookingInfo, setBookingInfo] = useState(null);
  const [bookingInfoJSON, setBookingInfoJSON] = useState("");
  const taxiIpassToken = localStorage.getItem("taxiIpassToken");
  // const [curl, setCurl] = useState("");
  // http://localhost:3000/payment-status?orderId=TaxiEmdiBAC56A96&amount=74000&message=&payment_type=VTCPAY&reference_number=TaxiEmdiBAC56A96&status=1&trans_ref_no=3544429&website_id=199758&signature=B8D50C0231CD58BFAEED012C866DBD671D6B450DEE0E55D3607A2E45597F3888
  useEffect(() => {
    handleBooking();
    if (queryParams.get("orderCode")) {
      handleBooking();
    } else {
      message.error("Không tìm thấy dữ liệu chuyến đi!");
      // history.push("/taxi");
    }
  }, []);

  const handleBooking = async () => {
    setLoading(true);
    const queryParams = new URLSearchParams(location.search);
    try {
      setLoading(true);
      const url = `/api/v1/gsm/transactions/details?orderCode=${queryParams.get(
        "orderCode"
      )}`;
      // setCurl(
      //   `curl -X GET '${$axios.defaults.baseURL}${url}' -H 'Authorization: ${taxiIpassToken}'`
      // );
      const res = await $axios.$get(url);
      setBookingInfoJSON(res);
      if (res.data.data.data) {
        setBookingInfo(res.data.data.data);
      } else {
        message.error("Không tìm thấy dữ liệu!");
        // history.push("/taxi");
      }
    } catch (error) {
      message.error(error.response.data.message || "Không tìm thấy dữ liệu!");
      // history.push("/taxi");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Spin tip="Tải dữ liệu" size="large" spinning={loading}>
      {/* <div className="mt-[20px]">
        {bookingInfo && bookingInfo?.orderCode && (
          <div>
            <p>{bookingInfo?.orderCode}</p>
            <a
              href={`http://localhost:3000/tracking?orderCode=${bookingInfo?.orderCode}`}
              alt=""
            >link</a>
          </div>
        )}
        <pre style={{ wordBreak: "break-all", whiteSpace: "normal" }}>
          <code>{curl}</code>
        </pre>
        <br />
      </div> */}
      <div className="bg-[#f6f6f6] h-screen">
        <div
          className="w-full h-[100px] absolute bg-primary"
          style={{
            backgroundImage: `url(/images/bg-form.png)`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center center",
          }}
        ></div>
        <div className="flex w-full z-10 justify-between items-center">
          <div className="w-[67px] ml-4 mt-4">
            <Button
              className="text-[14px]"
              icon={
                <LeftOutlined classID="text-primary" className="text-primary" />
              }
              onClick={() => {
                history.push(`/taxi`); // chuyển sang đường dẫn mới
              }}
            />
          </div>
          <div className="text-center mt-4 z-10">
            <a href="/taxi">
              <img
                src={"/images/logo-taxi.jpg"}
                alt=""
                className="w-[60px] rounded-full z-20"
              />
            </a>
          </div>
          <div className="w-[67px] h-8"></div>
        </div>
        {!_.isNull(bookingInfo) && (
          <div className="relative flex flex-col mt-[40px] justify-center items-center">
            {bookingInfo.paymentStatus === 1 ? (
              <div className="p-4 rounded-lg flex flex-col items-center gap-4 justify-center">
                <img
                  src="/images/payment-check.png"
                  alt=""
                  className="w-[120px]"
                />
                <div className="text-[18px] text-primary font-bold text-center mb-4 uppercase">
                  Thanh toán thành công
                </div>
                <div className="my-[20px] text-[16px] font-semibold text-primary text-center">
                  Bạn đã thực hiện thanh toán thành công , nhấn vào nút dưới đây
                  để theo dõi trạng thái chuyến đi
                </div>
                <Button
                  htmlType="sumit"
                  type="primary"
                  size="large"
                  className=" flex-1  h-[40px] rounded-lg"
                  loading={loading}
                  style={{ height: 40 }}
                  onClick={() => {
                    history.push(
                      `/tracking?orderCode=${bookingInfo?.orderCode}`
                    );
                  }}
                >
                  <span className="text-[16px] font-bold text-white">
                    {" "}
                    Theo dõi chuyến đi
                  </span>
                </Button>
              </div>
            ) : (
              <div className="flex flex-col p-4 justify-center items-center gap-4">
                <img
                  src="/images/payment-fail.png"
                  alt=""
                  className="w-[100px]"
                />
                <div className="text-[24px] text-[#D72F20] font-bold text-center uppercase">
                  Thanh toán thất bại
                </div>
                <div className="my-4 text-[18px] font-semibold text-red-500 text-center">
                  Đã xảy ra lỗi trong quá trình thanh toán
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </Spin>
  );
};

export default PaymentStatus;
